import { render, staticRenderFns } from "./JogadoresVeiculos.vue?vue&type=template&id=602468ea&"
import script from "./JogadoresVeiculos.vue?vue&type=script&lang=js&"
export * from "./JogadoresVeiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports